<ion-header *ngIf="platformSRV.isNative.value && fromModal" class="ion-no-border remove-margin-from-safe-area">
<ion-toolbar>
  <ion-buttons  slot="end">
    <ion-button (click)="closeModal()"
      ><ion-icon color="dark" name="close"></ion-icon
    ></ion-button>
  </ion-buttons>

  
  
</ion-toolbar>

</ion-header>

<ion-content>
  <div *ngIf="platformSRV.isNative.value && !fromModal" class="add-margin-top-to-safe-area"></div>

  <ion-grid >
    <ion-row>
      <ion-col style="text-align: center;">
      <img src="assets/images/logo-banner.png">
      </ion-col>
    </ion-row>
    <ion-row >
      <ion-col  sizeSm="12" sizeMd="8" offsetMd="2" sizeLg="6" offsetLg="3">

      
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col>

      
            <swiper 
                    #swiper
                    (swiper)="setSwiperInstance($event)"
                    [config]="config"
                    (slideChange)="onSlideChange($event)">
                    <ng-template *ngIf="!dataService.isProductionBuild" swiperSlide>
                      <ion-grid>
                        <ion-row>
                          <ion-col  style="text-align: center">
                            <h2 class="header-regular">Testing/Development mode</h2>
                          </ion-col>
                        </ion-row>
                        <ion-row >
                          <ion-col style="text-align: center">
                            <ion-label class="paragraph-regular" >Select a Parking Provider and an environment</ion-label>
                          </ion-col>
                        </ion-row>
                        <ion-row style="  
                        align-items: center;">
                          <ion-col size="12" >
                           <ion-card class="card-shadow-3">
                            <ion-item lines="none" >
                              <ion-label>Select Provider</ion-label>
                              <ion-select (ionChange)="clientChanged()"  [(ngModel)]="selectedTestingClient" >
                                <ion-select-option  *ngFor="let client of testingClients" [value]="client"  >{{client.clientName}}</ion-select-option>
                              </ion-select>
                            </ion-item>
                             
                           </ion-card>
                          </ion-col>
                        </ion-row>
                        <ion-row style="  
                        align-items: center;">
                          <ion-col size="12" >
                           <ion-card class="card-shadow-3">
                            <ion-item lines="none" >
                              <ion-label>Select Environment</ion-label>
                              <ion-select (ionChange)="envChanged()"   [(ngModel)]="selectedEnvironment" >
                                <ion-select-option  *ngFor="let env of environments" [value]="env" >{{env.base}}</ion-select-option>
                              </ion-select>
                            </ion-item>
                             
                           </ion-card>
                          </ion-col>
                        </ion-row>
                        <ion-row *ngIf="testingDomain ">
                          <ion-col>
                            <ion-card class="card-shadow-7">
                              <ion-grid class="ion-no-padding">
                                <ion-row>
                                  <ion-col class="ion-no-padding">
                                    <ion-item lines="none"  class="paragraph-regular ion-text-center">
                                      <ion-label>Domain</ion-label>
                                    </ion-item>
                                  </ion-col>
                                </ion-row>
                              </ion-grid>
                              <ion-item lines="none"  class="paragraph-input-fields-bold ion-text-center">
                                <ion-label>{{testingDomain?.webUrl? testingDomain?.webUrl : '-'}}</ion-label>
                                
                              </ion-item>
                             
                            </ion-card>
                          </ion-col>
                        </ion-row>
                      </ion-grid>
                    </ng-template>
                    <ng-template swiperSlide *ngIf="dataService.isProductionBuild" >
                      <ion-grid>
                        <ion-row>
                          <ion-col  style="text-align: center">
                            <h2 class="header-regular">Choose a Provider</h2>
                          </ion-col>
                        </ion-row>
                        <ion-row >
                          <ion-col style="text-align: center">
                            <ion-label class="paragraph-regular" >Select a Parking Provider from the list below</ion-label>
                          </ion-col>
                        </ion-row>
                        <ion-row style="  
                        align-items: center;">
                          <ion-col size="12" >
                           <ion-card class="card-shadow-3">
                            <ion-item lines="none" [disabled]="!isNative">
                              <ion-label>Select Provider</ion-label>
                              <ion-select   [(ngModel)]="selectedProductionClient" >
                                <ion-select-option  *ngFor="let client of productionClients" [value]="client" [disabled]="client['selected']" >{{client.clientName}}</ion-select-option>
                              </ion-select>
                            </ion-item>
                             
                           </ion-card>
                          </ion-col>
                        </ion-row>
                        
                      </ion-grid>
                      </ng-template>
                      <ng-template swiperSlide >
                        <ion-grid>
                          <ion-row>
                            <ion-col>
                              <h2  class="header-regular" style="text-align: center">
                                Choose language
                              </h2>
                            </ion-col>
                          </ion-row>
                          <ion-row >
                            <ion-col style="text-align: center">
                              <ion-label class="paragraph-regular" >Select a language from the list below</ion-label>
                            </ion-col>
                          </ion-row>
                          <ion-row >
                            <ion-col >
                              <ion-card class="card-shadow-3">
                                <ion-item lines="none">
                                  <ion-label>Choose language</ion-label>
                                  <ion-select  [(ngModel)]="choosenLanguage" >
                                    <ion-select-option  *ngFor="let language of languages;" [value]="language.code"  >{{language.name}}</ion-select-option>
                                  </ion-select>
                                </ion-item>
                                  
      
                               </ion-card>
                            
                              
                            </ion-col>
                          </ion-row>
                          
                          
                        </ion-grid>
                      </ng-template>
                      </swiper>
            
                    </ion-col>
        </ion-row>
        <ion-row>
          <ion-col  sizeSm="12" sizeMd="8" offsetMd="2" sizeLg="6" offsetLg="3">
            <ion-button  *ngIf="this.activeIndex==0 && dataService.isProductionBuild"(click)="next()" [disabled]="selectedProductionClient=='' || loadingLanguages" expand="block" color="primary">
              <span *ngIf="!loadingLanguages">Next</span><ion-spinner *ngIf="loadingLanguages" ></ion-spinner
                >
            </ion-button>
            <ion-button  *ngIf="this.activeIndex==0 && !dataService.isProductionBuild"(click)="next()" [disabled]="!selectedTestingClient || !selectedEnvironment || loadingLanguages" expand="block" color="primary">
              <span *ngIf="!loadingLanguages">Next</span><ion-spinner *ngIf="loadingLanguages" ></ion-spinner
                >
            </ion-button>
            <ion-button *ngIf="this.activeIndex==1" [disabled]="!choosenLanguage" expand="block" color="primary" (click)="continue()">
              Continue
            </ion-button>
            
          </ion-col>
        </ion-row>
        <ion-row *ngIf="this.activeIndex==1 && isNative">
          <ion-col sizeSm="12" sizeMd="8" offsetMd="2" sizeLg="6" offsetLg="3">
            <ion-button fill="clear"  expand="block" color="primary" (click)="back()">
              Back
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-col>
    </ion-row>
    
   
    
 </ion-grid>



</ion-content>